import { Button, DrawerBodyWrapper, DrawerFooterWrapper, Select } from '@base'
import { DRAWER_TYPES, strings } from '@constants'
import { getAllUsers, getOrganisation } from '@data'
import { showLoader } from '@data/state/action'
import { toggleDrawer } from '@data/state/action/root'
import { useForceUpdate } from '@hooks'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

const initialState = () => {
	const _state = {
		Org: {
			value: '',
			id: 'organisation_id',
			required: true,
			disabled: false,
			label: strings(['select', 'organisation']),
			placeholder: strings(['select', 'organisation']),
		},
	}
	return _state
}

const RequestForCredit = () => {
	const [formState, setFormState] = useState(initialState())
	const [forceUpdate, update] = useForceUpdate()
	const [orgList, setOrgList] = useState()

	const dispatch = useDispatch()
	useEffect(() => {
		getAllUsers()
			.then((response) => {
				setOrgList(response)
			})
			.catch((err) => console.log(err))
	}, [])

	const _orgList = orgList?.map((item) => {
		item['display_name'] = item.organisation_name ? `${item.organisation_name + ' (' + item.organisation_id + ')'}` : `(${item.organisation_id})`
		return item
	})

	const onChange = (key) => (value) => {
		setFormState((state) => ({
			...state,
			[key]: {
				...state[key],
				...{ value },
			},
		}))
	}

	const mergeOrganisationHandler = () => {
		dispatch(toggleDrawer(false))
		dispatch(showLoader(true))
		getOrganisation(formState.Org.value.organisation_id)
			.then((response) => {
				dispatch(
					toggleDrawer(true, DRAWER_TYPES.ADD_CREDIT_LIMIT, {
						label: strings(['add', 'credit', 'limit']),
						orgId: formState?.Org?.value?.organisation_id,
						userData: response?.client_details,
						commodities: response?.commodity,
						outletUpdate: update,
					})
				)
			})
			.catch((err) => console.log(err))
			.finally(() => {
				dispatch(showLoader(false))
			})
	}

	return (
		<>
			<DrawerBodyWrapper>
				<Select
					label={formState.Org.label}
					id={formState.Org.id}
					placeholder={formState.Org.placeholder}
					value={formState.Org.value}
					onChange={onChange('Org')}
					data={_orgList}
					displayKey='display_name'
					primaryKey='organisation_id'
				/>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button small disabled={formState.Org.value === ''} onClick={mergeOrganisationHandler}>
					{strings('submit')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default RequestForCredit
